var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btn",on:{"click":_vm.toTop}},[_c('el-button',{attrs:{"type":"info","icon":"el-icon-top","circle":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }